import React from 'react';
import App from '../../../App/App';
// Override some styles
import './App.scss';

const AppNuttall = (props) => (
  <App {...props} containerExtraClassName="alan-nuttall-flexeserve-eu" />
);
export default AppNuttall;
